export const PERMISSIONS = {
  CREATE_YELLOW_ADJ: "create-yellow-adj",
  DISMISS_ALERT: "dismiss-alert",
  VIEW_NOTIFICATION_LOG: "view-notification-log",
  VIEW_NOTIFICATION_SETTING: "view-notification-setting",
  VIEW_CONTACT_INFO_SETTING: "view-contact-info-setting",
  EDIT_MT: "edit-manual-transfer",
  GO_APPS: "go-apps",
  VIEW_PMRJIT: "view-pmrjit-report",
  EDIT_PMRJIT: "edit-pmrjit-report",
  VIEW_EACHES_PRODUCT_DETAILS_INVENTORY_PAGE:
    "view-eaches-product-details-inventory-page"
};
